export default __webpack_public_path__ + "static/media/clock.e28479e6.svg";